import Tag, { TagProps } from "components/Tag/Tag";

import classNames from "classnames";
import { YesNoType } from "types/YesNoType";
import { ScanText } from "lucide-react";
import FullTextIcon from "design_system/color_icons/FullTextIcon";

type CitationTagProps = {
  paperIndex?: number;
  quoteIndex?: number;
  variant?: YesNoType;
  showFullTextIcon?: boolean;
  showQuoteIcon?: boolean;
} & Omit<TagProps, "variant" | "label">;

export const CitationTag = ({
  paperIndex,
  quoteIndex,
  variant,
  className,
  showFullTextIcon = false,
  showQuoteIcon = false,
  ...otherProps
}: CitationTagProps) => {
  const label =
    paperIndex !== undefined
      ? quoteIndex !== undefined
        ? `${paperIndex + 1}.${quoteIndex + 1}`
        : `${paperIndex + 1}`
      : "—";

  return (
    <Tag
      label={label}
      icon={
        showFullTextIcon ? (
          <FullTextIcon size="sm" />
        ) : showQuoteIcon ? (
          <ScanText size={16} />
        ) : null
      }
      variant={variant as TagProps["variant"]}
      className={classNames(className, "text-fg-base! bg-bg-subtle font-bold!")}
      {...otherProps}
    />
  );
};
